import { useState, useEffect } from "react";
import Header from "../Header/Header1";
import "./bot.scss";
import { Button, FormLabel } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Box,
  Grid,
  Modal,
  TablePagination,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import consts from "../../constant";
import usercalls from "../../Axios";
import toast, { Toaster } from "react-hot-toast";
import axios from "axios";
import { io } from "socket.io-client";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "var(--common-card-bg)",
  borderRadius: "10px",
  p: 2,
};

const DCABot = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [createDcaBot, setCreateDcaBot] = useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [strategies, setStrategies] = useState({});
  const [strategiesLoading, setStrategiesLoading] = useState(false);
  const [pairs, setPairs] = useState([]);
  const [pairsLoading, setPairsLoading] = useState(false);
  const [currencyRates, setCurrencyRates] = useState({});
  const path = usercalls();

  const [formData, setFormData] = useState({
    name: "",
    pairs: "",
    base_order_volume_type: "",
    base_order_volume: "",
    take_profit_type: "",
    take_profit: "",
    risk_reduction_percentage: "",
    strategy_list: [],
    profit_currency: "quote_currency",
    start_order_type: "",
    strategy: "",
    safety_order_volume_type: "",
    stop_loss_type: "",
    leverage_type: "",
    safety_order_step_percentage: "",
    safety_order_volume: "",
    max_safety_orders: "",
    active_safety_orders_count: "",
    martingale_volume_coefficient: "",
    martingale_step_coefficient: "",
  });

  const [savedBots, setSavedBots] = useState([]);
  const [editIndex, setEditIndex] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalBots, setTotalBots] = useState(0);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "pairs") {
      const pair = String(value || "")
        .split(",")[0]
        .trim();
      if (pair) {
        getCurrencyRates(pair);
      } else {
        setCurrencyRates({});
      }
    }
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const getCurrencyRates = async (pair) => {
    try {
      const url = `https://api.3commas.io/public/api/ver1/accounts/currency_rates?market_code=kucoin&pair=${pair}`;
      const { data } = await axios.get(url);
      if (data) {
        setCurrencyRates(data);
      } else {
        setCurrencyRates({});
      }
    } catch (err) {
      setCurrencyRates({});
    }
  };

  const getPairs = async () => {
    try {
      setPairsLoading(true);
      const url = `${consts.BackendUrl}/bots/get-trading-pairs`;
      const payload = {
        market: state?.market_code || state?.market,
      };
      const response = await path.postCall({ url, payload });
      const result = await response.json();
      if (result?.success || Array.isArray(result)) {
        setPairs(result.result || result || []);
      } else {
        setPairs([]);
      }
      setPairsLoading(false);
    } catch (err) {
      console.error("Error fetching pairs:", err);
      setPairs([]);
      setPairsLoading(false);
    }
  };
  useEffect(() => {
    const socket = io(consts?.socketUrl, {
      path: "/socket",
    });
    socket.on("connect", () => {
      socket.emit("join", {
        room: localStorage.getItem("use"),
      });
      console.log("socket connected");
    });

    socket.on("dca_bot_closed", (data) => {
      try {
        console.log(data, "socket smart_trade_update");
        getSavedBots();
      } catch (e) {
        console.log(e);
      }
    });

    return () => {
      socket.disconnect();
    };
  }, []);
  const getStrategies = async () => {
    try {
      setStrategiesLoading(true);
      const url = `${consts.BackendUrl}/bots/get-strategyList`;
      const response = await path.postCall({
        url,
        payload: {},
      });
      const result = await response.json();
      if (result?.success) {
        const normalized = {};
        if (Array.isArray(result.result)) {
          result.result.forEach((strategy) => {
            const key =
              typeof strategy === "string"
                ? strategy
                : strategy.strategy || strategy.key;
            normalized[key] = {
              name: strategy.name || key,
              strategy_type: strategy.strategy_type || "default",
            };
          });
        } else if (typeof result.result === "object") {
          Object.assign(normalized, result.result);
        }
        setStrategies(normalized);
      } else {
        setStrategies({});
      }
      setStrategiesLoading(false);
    } catch (err) {
      console.error("Error fetching strategies:", err);
      setStrategies({});
      setStrategiesLoading(false);
    }
  };

  const getSavedBots = async ({
    pageValue = page,
    rowsPerPageValue = rowsPerPage,
  } = {}) => {
    try {
      const url = `${consts.BackendUrl}/bots/get-dca-botlist?page=${pageValue + 1}&limit=${rowsPerPageValue}`;
      const payload = {
        account_id: state?.account_id || state?.id,
        limit: rowsPerPageValue,
        offset: pageValue * rowsPerPageValue,
      };
      const response = await path.postCall({ url, payload });
      const result = await response.json();

      if (result?.success) {
        const bots = result?.result?.docs || [];
        const totalDocs = Number(result?.result?.totalDocs || 0);

        if (totalDocs > 0 && bots.length === 0 && pageValue > 0) {
          setPage(Math.max(0, Math.ceil(totalDocs / rowsPerPageValue) - 1));
          return;
        }

        setSavedBots(bots);
        setTotalBots(totalDocs);
      } else {
        setSavedBots([]);
        setTotalBots(0);
      }
    } catch (err) {
      console.error("Error fetching saved bots:", err);
      setSavedBots([]);
      setTotalBots(0);
    }
  };

  useEffect(() => {
    getPairs();
  }, []);

  useEffect(() => {
    getStrategies();
  }, []);

  useEffect(() => {
    getSavedBots();
  }, [page, rowsPerPage]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleStrategyChange = (e) => {
    const { value } = e.target;
    setFormData((prev) => ({
      ...prev,
      strategy_list: typeof value === "string" ? value.split(",") : value,
    }));
  };

  const validateForm = (data) => {
    if (!data.name || data.name.trim().length === 0) return "name is required";
    if (!data.pairs || data.pairs.trim().length === 0)
      return "pairs is required";
    if (!data.base_order_volume_type)
      return "base_order_volume_type is required";
    if (!data.base_order_volume) return "base_order_volume is required";
    if (!isNumeric(data.base_order_volume))
      return "base_order_volume must be numeric and > 0";
    if (parseFloat(data.base_order_volume) <= 0)
      return "base_order_volume must be greater than 0";
    if (
      !data.strategy_list ||
      !Array.isArray(data.strategy_list) ||
      data.strategy_list.length === 0
    )
      return "strategy_list must have at least 1 strategy";
    if (!data.take_profit_type) return "take_profit_type is required";
    if (!["total", "base"].includes(data.take_profit_type))
      return "Invalid take_profit_type";
    if (!data.take_profit && data.take_profit !== 0)
      return "take_profit is required";
    if (!isNumeric(data.take_profit)) return "take_profit must be numeric";
    if (!data.risk_reduction_percentage && data.risk_reduction_percentage !== 0)
      return "risk_reduction_percentage is required";
    if (!isNumeric(data.risk_reduction_percentage))
      return "risk_reduction_percentage must be numeric";
    if (
      parseFloat(data.risk_reduction_percentage) < 0 ||
      parseFloat(data.risk_reduction_percentage) > 100
    )
      return "risk_reduction_percentage must be between 0 and 100";
    if (!data.safety_order_step_percentage)
      return "safety_order_step_percentage is required";
    if (!isNumeric(data.safety_order_step_percentage))
      return "safety_order_step_percentage must be numeric";
    if (parseFloat(data.safety_order_step_percentage) <= 0)
      return "safety_order_step_percentage must be greater than 0";
    if (!data.safety_order_volume) return "safety_order_volume is required";
    if (!isNumeric(data.safety_order_volume))
      return "safety_order_volume must be numeric";
    if (parseFloat(data.safety_order_volume) <= 0)
      return "safety_order_volume must be greater than 0";
    if (!data.max_safety_orders && data.max_safety_orders !== 0)
      return "max_safety_orders is required";
    if (!Number.isInteger(Number(data.max_safety_orders)))
      return "max_safety_orders must be integer";
    if (
      Number(data.max_safety_orders) < 0 ||
      Number(data.max_safety_orders) > 200
    )
      return "max_safety_orders must be between 0 and 200";
    if (
      !data.active_safety_orders_count &&
      data.active_safety_orders_count !== 0
    )
      return "active_safety_orders_count is required";
    if (!Number.isInteger(Number(data.active_safety_orders_count)))
      return "active_safety_orders_count must be integer";
    if (Number(data.active_safety_orders_count) < 0)
      return "active_safety_orders_count must be 0 or greater";
    if (
      !data.martingale_volume_coefficient &&
      data.martingale_volume_coefficient !== 0
    )
      return "martingale_volume_coefficient is required";
    if (!isNumeric(data.martingale_volume_coefficient))
      return "martingale_volume_coefficient must be numeric";
    if (
      parseFloat(data.martingale_volume_coefficient) < 0.1 ||
      parseFloat(data.martingale_volume_coefficient) > 10
    )
      return "martingale_volume_coefficient must be between 0.1 and 10";
    if (
      !data.martingale_step_coefficient &&
      data.martingale_step_coefficient !== 0
    )
      return "martingale_step_coefficient is required";
    if (!isNumeric(data.martingale_step_coefficient))
      return "martingale_step_coefficient must be numeric";
    if (
      parseFloat(data.martingale_step_coefficient) < 0.1 ||
      parseFloat(data.martingale_step_coefficient) > 10
    )
      return "martingale_step_coefficient must be between 0.1 and 10";

    // Optional fields validation
    if (
      data.profit_currency &&
      !["quote_currency", "base_currency"].includes(data.profit_currency)
    )
      return "Invalid profit_currency";
    if (
      data.start_order_type &&
      !["market", "limit"].includes(data.start_order_type)
    )
      return "Invalid start_order_type";
    if (
      data.stop_loss_type &&
      !["stop_loss", "stop_loss_and_disable_bot"].includes(data.stop_loss_type)
    )
      return "Invalid stop_loss_type";

    return null;
  };

  const isNumeric = (value) => {
    return value !== "" && !isNaN(value) && !isNaN(parseFloat(value));
  };
  const handleCreateDcaBot = async () => {
    const err = validateForm(formData);
    if (err) return toast.error(err);

    setSubmitLoading(true);
    try {
      const url = `${consts.BackendUrl}/bots/create-dca-bot`;
      const payload = {
        id: editIndex !== null ? savedBots[editIndex]?.id : undefined,
        exchange_id: state?.id || state?.account_id,
        name: formData.name.trim(),
        pairs: formData.pairs.trim(),
        base_order_volume_type:
          formData.base_order_volume_type || "quote_currency",
        base_order_volume: parseFloat(formData.base_order_volume),
        take_profit_type: formData.take_profit_type,
        take_profit: parseFloat(formData.take_profit || 0),
        risk_reduction_percentage: parseFloat(
          formData.risk_reduction_percentage ?? 0,
        ),
        strategy_list: (Array.isArray(formData.strategy_list)
          ? formData.strategy_list
          : (formData.strategy_list || "").split(",")
        )
          .filter((s) => s && s.trim())
          .map((s) => {
            // map to required object shape { strategy, options }
            if (typeof s === "string") {
              return { strategy: s.trim(), options: {} };
            }
            if (typeof s === "object" && s !== null) {
              return { strategy: s.strategy || "", options: s.options || {} };
            }
            return { strategy: String(s).trim(), options: {} };
          }),
        profit_currency: formData.profit_currency || "quote_currency",
        start_order_type: formData.start_order_type || "limit",
        strategy: formData.strategy || "long",
        stop_loss_type: formData.stop_loss_type || "stop_loss",
        leverage_type: formData.leverage_type || "not_specified",
        safety_order_step_percentage: parseFloat(
          formData.safety_order_step_percentage,
        ),
        safety_order_volume: parseFloat(formData.safety_order_volume),
        max_safety_orders: parseInt(formData.max_safety_orders, 10),
        active_safety_orders_count: parseInt(
          formData.active_safety_orders_count,
          10,
        ),
        martingale_volume_coefficient: parseFloat(
          formData.martingale_volume_coefficient,
        ),
        martingale_step_coefficient: parseFloat(
          formData.martingale_step_coefficient,
        ),
      };

      if (payload.id === undefined) {
        delete payload.id;
      }

      const response = await path.postCall({ url, payload });
      const result = await response.json();

      if (result?.success) {
        toast.success(result?.message || "DCA Bot created successfully");
        setCreateDcaBot(false);
        await getSavedBots();
        setEditIndex(null);
        setFormData({
          name: "",
          pairs: "",
          base_order_volume_type: "",
          base_order_volume: "",
          take_profit_type: "",
          take_profit: "",
          risk_reduction_percentage: "",
          strategy_list: [],
          profit_currency: "quote_currency",
          start_order_type: "",
          strategy: "",
          safety_order_volume_type: "",
          stop_loss_type: "",
          leverage_type: "",
          safety_order_step_percentage: "",
          safety_order_volume: "",
          max_safety_orders: "",
          active_safety_orders_count: "",
          martingale_volume_coefficient: "",
          martingale_step_coefficient: "",
        });
      } else {
        toast.error(result?.message || "Failed to create DCA Bot");
      }
    } catch (e) {
      console.error(e);
      toast.error("Cannot create DCA Bot");
    } finally {
      setSubmitLoading(false);
    }
  };

  const handleSubmit = async () => {
    await handleCreateDcaBot();
  };

  const handleEdit = (item, index) => {
    const mapped = {
      name: item.name || "",
      pairs: Array.isArray(item.pairs)
        ? item.pairs.join(",")
        : item.pairs || "",
      base_order_volume_type: item.base_order_volume_type || "quote_currency",
      base_order_volume: item.base_order_volume || "",
      take_profit_type: item.take_profit_type || "base",
      take_profit: item.take_profit || "",
      risk_reduction_percentage: item.risk_reduction_percentage || "0",
      strategy_list: Array.isArray(item.strategy_list)
        ? item.strategy_list.map((s) =>
            typeof s === "string" ? s : s.strategy || "",
          )
        : [],
      profit_currency: item.profit_currency || "quote_currency",
      start_order_type: item.start_order_type || "limit",
      strategy: item.strategy || "long",
      safety_order_volume_type:
        item.safety_order_volume_type || "quote_currency",
      stop_loss_type: item.stop_loss_type || "stop_loss",
      leverage_type: item.leverage_type || "not_specified",
      safety_order_step_percentage: item.safety_order_step_percentage || "",
      safety_order_volume: item.safety_order_volume || "",
      max_safety_orders: item.max_safety_orders || "",
      active_safety_orders_count: item.active_safety_orders_count || "",
      martingale_volume_coefficient: item.martingale_volume_coefficient || "",
      martingale_step_coefficient: item.martingale_step_coefficient || "",
      _id: item._id,
    };
    console.log(mapped, "MAPPED");
    setFormData(mapped);
    const pair = String(mapped.pairs || "")
      .split(",")[0]
      .trim();
    if (pair) {
      getCurrencyRates(pair);
    } else {
      setCurrencyRates({});
    }
    setEditIndex(index);
    setCreateDcaBot(true);
  };

  const handleDelete = async (botId) => {
    setDeleteLoading(true);
    try {
      const url = `${consts.BackendUrl}/bots/delete-dca-bot`;
      const payload = { id: botId };
      const response = await path.postCall({ url, payload });
      const result = await response.json();

      if (!result?.success) {
        toast.error(result?.message || "Failed to delete bot");
        return;
      }

      toast.success(result?.message || "Bot deleted successfully");

      await getSavedBots();
    } catch (err) {
      console.error("Error deleting bot:", err);
      toast.error(err?.message || "Cannot delete bot");
    } finally {
      setDeleteLoading(false);
    }
  };

  const [deleteIndex, setDeleteIndex] = useState(null);
  return (
    <div className="market-full page_align" style={{ minHeight: "100vh" }}>
      <Header />
      <Toaster />

      {totalBots === 0 ? (
        // CENTER DESIGN
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          style={{ minHeight: "60vh" }}
        >
          <Grid item xs={11} sm={8} md={6} lg={4}>
            <div
              style={{
                border: "1px solid #2a2a2a",
                borderRadius: "12px",
                padding: "40px",
                textAlign: "center",
                background: "#0f0f0f",
              }}
            >
              <h2 style={{ marginBottom: "30px" }}>DCA Bot</h2>

              <Button
                variant="contained"
                onClick={() => setCreateDcaBot(true)}
                style={{
                  padding: "10px 30px",
                  borderRadius: "8px",
                }}
              >
                Create DCA Bot{" "}
              </Button>
            </div>
          </Grid>
        </Grid>
      ) : (
        <>
          <Grid container className="mb-20">
            <Grid item xs={12}>
              <div className="support-head bot_dash display-2 mb-20 p-2 flex-wrap">
                <div className="bot-heading"> DCA Bot</div>

                <div className="bot_comman_btn">
                  <Button onClick={() => setCreateDcaBot(true)}>
                    Create DCA Bot
                  </Button>
                </div>
              </div>
            </Grid>
          </Grid>

          <Grid container spacing={2} className="mt-20">
            {savedBots.map((item, index) => (
              <Grid item xs={12} sm={12} md={6} lg={6} key={index}>
                <div className="bot_container contain-width">
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <div className="display-2">
                        <h3>Profile</h3>
                        <div className="bot_comman_btn green-btn">
                          <Button
                            onClick={() => {
                              navigate("/dcabottrade", {
                                state: { id: item.id },
                              });
                            }}
                          >
                            View Bot
                          </Button>
                        </div>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={6}>
                      <div className="display-2">
                        <h4>Bot Name</h4>
                        <div>{item.name || "----"}</div>
                      </div>
                    </Grid>
                    {/* <Grid item xs={12} sm={12} md={12} lg={6}>
                      <div className="display-2">
                        <h4>Exchange Name</h4>
                        <div>{item.account_name || "----"}</div>
                      </div>
                    </Grid> */}
                    <Grid item xs={12} sm={12} md={12} lg={6}>
                      <div className="display-2">
                        <h4>Pairs</h4>
                        <div>
                          {Array.isArray(item.pairs)
                            ? item.pairs.join(",")
                            : item.pairs || "-"}
                        </div>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={6}>
                      <div className="display-2">
                        <h4>Volume</h4>
                        <div>{item.base_order_volume || "----"}</div>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={6}>
                      <div className="display-2">
                        <h4>Take Profit</h4>
                        <div>{item.take_profit || "----"}</div>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={6}>
                      <div className="display-2">
                        <h4>Risk Percentage</h4>
                        <div>{item.risk_reduction_percentage || "----"}</div>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <div className="display-2">
                        <div className="bot_comman_btn">
                          <Button onClick={() => handleEdit(item, index)}>
                            Edit
                          </Button>
                        </div>

                        <div className="bot_comman_btn red-btn">
                          <Button
                            onClick={() => {
                              console.log("Delete bot with id:", item);
                              setDeleteIndex(item.id);
                              setOpenConfirm(true);
                            }}
                          >
                            Delete
                          </Button>
                        </div>
                      </div>
                    </Grid>
                  </Grid>
                </div>
              </Grid>
            ))}
          </Grid>
          <div
            className="display-2 mt-20"
            style={{ justifyContent: "flex-end" }}
          >
            <TablePagination
              component="div"
              count={totalBots || savedBots.length}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPageOptions={[10]}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </div>
        </>
      )}
      <Modal
        open={createDcaBot}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className="display-2 p-20">
            <div className="coins">
              {editIndex !== null ? "Edit DCA Bot" : "Create DCA Bot"}
            </div>
            <HighlightOffIcon
              className="cursor"
              sx={{ fill: "var(--clr-font)", fontSize: "25px !important" }}
              onClick={() => setCreateDcaBot(false)}
            />
          </div>

          <Box
            display="flex"
            flexDirection="column"
            gap={2}
            mt={2}
            className=""
            style={{ maxHeight: "400px", overflow: "auto" }}
          >
            <FormLabel
              size="small"
              sx={{ color: "var(--clr-font)", fontSize: "12px", mt: 0 }}
            >
              Current Price : {currencyRates?.last ? currencyRates.last : 0}{" "}
              USDT
            </FormLabel>
            <TextField
              label="Name (required)"
              name="name"
              fullWidth
              className="bot-input"
              value={formData.name}
              onChange={handleChange}
              required
            />

            <FormControl fullWidth required>
              <InputLabel id="base-order-volume-type-label">
                Base Order Volume Type (required)
              </InputLabel>
              <Select
                className="bot-select"
                labelId="base-order-volume-type-label"
                id="base_order_volume_type"
                name="base_order_volume_type"
                value={formData.base_order_volume_type || ""}
                onChange={handleChange}
                label="Base Order Volume Type (required)"
                required
              >
                <MenuItem value="" disabled>
                  Select Base Order Volume Type
                </MenuItem>
                <MenuItem value="quote_currency">Quote Currency</MenuItem>
                <MenuItem value="base_currency">Base Currency</MenuItem>
              </Select>
            </FormControl>

            {editIndex !== null ? (
              <TextField
                label="Pairs (required)"
                name="pairs"
                fullWidth
                className="bot-input"
                value={formData.pairs}
                required
                InputProps={{ readOnly: true }}
              />
            ) : pairs && pairs.length > 0 ? (
              <FormControl fullWidth required>
                <InputLabel id="pair-label">Pairs (required)</InputLabel>
                <Select
                  className="bot-select"
                  fullWidth
                  name="pairs"
                  value={formData.pairs}
                  onChange={handleChange}
                  labelId="pair-label"
                  id="pairs"
                  label="Pairs (required)"
                  disabled={pairsLoading}
                  required
                >
                  <MenuItem value="">Select Pair</MenuItem>
                  {pairs.map((p, idx) => {
                    const label =
                      typeof p === "string"
                        ? p
                        : p.pair || p.symbol || p.name || p.label;
                    const value =
                      typeof p === "string"
                        ? p
                        : p.pair || p.symbol || p.name || p.value;
                    return (
                      <MenuItem key={idx} value={value}>
                        {label}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            ) : (
              <TextField
                label="Pairs (required)"
                name="pairs"
                fullWidth
                className="bot-input"
                value={formData.pairs}
                onChange={handleChange}
                required
              />
            )}

            <FormControl fullWidth required>
              <InputLabel id="strategy-list-label">
                Strategy List (required)
              </InputLabel>
              <Select
                className="bot-select"
                labelId="strategy-list-label"
                id="strategy_list"
                multiple
                name="strategy_list"
                value={formData.strategy_list || []}
                onChange={handleStrategyChange}
                label="Strategy List (required)"
                disabled={strategiesLoading}
                required
                renderValue={(selected) => {
                  if (!selected || selected.length === 0) {
                    return (
                      <span style={{ color: "var(--clr-font)" }}>
                        Select Strategies
                      </span>
                    );
                  }
                  return selected
                    .map((key) => {
                      const strategy = strategies[key];
                      return strategy?.name || key;
                    })
                    .join(", ");
                }}
              >
                {Object.entries(strategies || {}).map(([key, strategy]) => {
                  if (["Trading View custom signal"].includes(strategy.name))
                    return null;
                  return (
                    <MenuItem key={key} value={key}>
                      {strategy.name} ({strategy.strategy_type})
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>

            <FormControl fullWidth>
              <InputLabel id="start-order-type-label">
                Start Order Type
              </InputLabel>
              <Select
                className="bot-select"
                labelId="start-order-type-label"
                id="start_order_type"
                name="start_order_type"
                value={formData.start_order_type || ""}
                onChange={handleChange}
                label="Start Order Type"
              >
                <MenuItem value="" disabled>
                  Select Start Order Type
                </MenuItem>
                <MenuItem value="market">Market</MenuItem>
                <MenuItem value="limit">Limit</MenuItem>
              </Select>
            </FormControl>

            <TextField
              label="Base Order Volume (required)"
              name="base_order_volume"
              type="number"
              fullWidth
              className="bot-input"
              value={formData.base_order_volume}
              onChange={handleChange}
              required
            />

            <FormControl fullWidth>
              <InputLabel id="take-profit-type-label">
                Take Profit Type
              </InputLabel>
              <Select
                className="bot-select"
                labelId="take-profit-type-label"
                id="take_profit_type"
                name="take_profit_type"
                value={formData.take_profit_type || ""}
                onChange={handleChange}
                label="Take Profit Type"
              >
                <MenuItem value="" disabled>
                  Select Take Profit Type
                </MenuItem>
                <MenuItem value="total">Total</MenuItem>
                <MenuItem value="base">Base</MenuItem>
              </Select>
            </FormControl>

            <TextField
              label="Take Profit (%) (required)"
              name="take_profit"
              type="number"
              fullWidth
              className="bot-input"
              value={formData.take_profit}
              onChange={handleChange}
              required
            />

            <TextField
              label="Risk Reduction Percentage (%) (required)"
              name="risk_reduction_percentage"
              type="number"
              fullWidth
              className="bot-input"
              value={formData.risk_reduction_percentage}
              onChange={handleChange}
              inputProps={{ min: 0, max: 100, step: 0.1 }}
              required
            />

            <TextField
              label="Safety Order Step Percentage (%) (required)"
              name="safety_order_step_percentage"
              type="number"
              fullWidth
              className="bot-input"
              value={formData.safety_order_step_percentage}
              onChange={handleChange}
              required
            />

            <TextField
              label="Safety Order Volume (required)"
              name="safety_order_volume"
              type="number"
              fullWidth
              className="bot-input"
              value={formData.safety_order_volume}
              onChange={handleChange}
              required
            />

            <TextField
              label="Max Safety Orders (required)"
              name="max_safety_orders"
              type="number"
              fullWidth
              className="bot-input"
              value={formData.max_safety_orders}
              onChange={handleChange}
              required
            />

            <TextField
              label="Active Safety Orders Count (required)"
              name="active_safety_orders_count"
              type="number"
              fullWidth
              className="bot-input"
              value={formData.active_safety_orders_count}
              onChange={handleChange}
              required
            />

            <TextField
              label="Martingale Volume Coefficient (required)"
              name="martingale_volume_coefficient"
              type="number"
              fullWidth
              className="bot-input"
              value={formData.martingale_volume_coefficient}
              onChange={handleChange}
              required
            />

            <TextField
              label="Martingale Step Coefficient (required)"
              name="martingale_step_coefficient"
              type="number"
              fullWidth
              className="bot-input"
              value={formData.martingale_step_coefficient}
              onChange={handleChange}
              required
            />
            <TextField
              label="Min Price for New Deals (Optional)"
              name="min_price"
              type="number"
              fullWidth
              className="bot-input"
              value={formData.min_price}
              onChange={handleChange}
              required
            />
            <TextField
              label="Max Price for New Deals (Optional)"
              name="max_price"
              type="number"
              fullWidth
              className="bot-input"
              value={formData.max_price}
              onChange={handleChange}
              required
            />
            <FormControl fullWidth>
              <InputLabel id="profit-currency-label">
                Profit Currency (optional)
              </InputLabel>
              <Select
                className="bot-select"
                labelId="profit-currency-label"
                id="profit_currency"
                name="profit_currency"
                value={formData.profit_currency}
                onChange={handleChange}
                label="Profit Currency (optional)"
              >
                <MenuItem value="base_currency">Base Currency</MenuItem>
                <MenuItem value="quote_currency">Quote Currency</MenuItem>
              </Select>
            </FormControl>

            <FormControl fullWidth>
              <InputLabel id="strategy-label">Strategy (optional)</InputLabel>
              <Select
                className="bot-select"
                labelId="strategy-label"
                id="strategy"
                name="strategy"
                value={formData.strategy || ""}
                onChange={handleChange}
                label="Strategy (optional)"
              >
                <MenuItem value="" disabled>
                  Select Strategy
                </MenuItem>
                <MenuItem value="long">Long</MenuItem>
                <MenuItem value="short">Short</MenuItem>
              </Select>
            </FormControl>

            {/* <FormControl fullWidth>
              <InputLabel id="leverage-type-label">
                Leverage Type (optional)
              </InputLabel>
              <Select
                className="bot-select"
                labelId="leverage-type-label"
                id="leverage_type"
                name="leverage_type"
                value={formData.leverage_type || ""}
                onChange={handleChange}
                label="Leverage Type (optional)"
              >
                <MenuItem value="" disabled>
                  Select Leverage Type
                </MenuItem>
                <MenuItem value="cross">Cross</MenuItem>
                <MenuItem value="isolated">Isolated</MenuItem>
                <MenuItem value="not_specified">Not Specified</MenuItem>
              </Select>
            </FormControl> */}

            <FormControl fullWidth>
              <InputLabel id="stop-loss-type-label">
                Stop Loss Type (optional)
              </InputLabel>
              <Select
                className="bot-select"
                labelId="stop-loss-type-label"
                id="stop_loss_type"
                name="stop_loss_type"
                value={formData.stop_loss_type || ""}
                onChange={handleChange}
                label="Stop Loss Type (optional)"
              >
                <MenuItem value="" disabled>
                  Select Stop Loss Type
                </MenuItem>
                <MenuItem value="stop_loss">Stop Loss</MenuItem>
                <MenuItem value="stop_loss_and_disable_bot">
                  Stop Loss and Disable Bot
                </MenuItem>
              </Select>
            </FormControl>
          </Box>

          <div className="bot_comman_btn display-3 mt-20">
            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmit}
              disabled={submitLoading}
            >
              {submitLoading ? "Submitting..." : "Submit"}
            </Button>
          </div>
        </Box>
      </Modal>

      <Modal open={openConfirm} onClose={() => setOpenConfirm(false)}>
        <Box sx={style}>
          <div className="p-20">Are you sure want to delete this bot?</div>

          <div className="display-2">
            <div className="bot_comman_btn display-3 mt-20">
              <Button
                variant="contained"
                onClick={() => {
                  setOpenConfirm(false);
                  setDeleteIndex(null);
                }}
              >
                No
              </Button>
            </div>

            <div className="bot_comman_btn display-3 mt-20">
              <Button
                variant="contained"
                color="error"
                onClick={() => {
                  handleDelete(deleteIndex);
                  setOpenConfirm(false);
                  setDeleteIndex(null);
                }}
                disabled={deleteLoading}
              >
                {deleteLoading ? "Deleting..." : "Yes"}
              </Button>
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default DCABot;
